module.exports = __webpack_public_path__ + "img/profile.17f8759b.svg";